import api from './api';

const notificationService = {
  // Get all notifications with pagination
  getNotifications: async (page = 1, limit = 10, isRead = null) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (isRead !== null) {
      params.append('isRead', isRead.toString());
    }

    const response = await api.get(`/notifications?${params}`);
    return response;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response;
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    const response = await api.patch('/notifications/mark-all-read');
    return response;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response;
  },

  // Clear all read notifications
  clearReadNotifications: async () => {
    const response = await api.delete('/notifications/clear-read');
    return response;
  }
};

export default notificationService;
